// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import Select from "react-select";
// import { useDispatch } from "react-redux";
// import { updateProfleAction } from "../../../redux/actions/user/userAction";
// import { connect } from "react-redux";
// import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
// import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";

// export const SystemExperience = (props) => {
//   const customStyles = {
//     control: (base, state) => ({
//       ...base,
//       top: "5px",
//       // Overwrittes the different states of border
//       borderColor: state.isFocused ? "#309CCA" : "#309CCA",
//     }),
//   };

//   const groupByKey = (array, key) => {
//     return array.reduce((hash, obj) => {
//       if (obj[key] === undefined) return hash;
//       return Object.assign(hash, {
//         [obj[key]]: (hash[obj[key]] || []).concat(obj),
//       });
//     }, {});
//   };

//   const dispatch = useDispatch();
//   const [groupedOptions, setGroupedOptions] = useState([]);
//   const [inputData, setInputData] = useState([]);
//   const [systemExperience, setSystemExperience] = useState([]);
//   // const [deleteSystemExperienceId, setDeleteSystemExperienceID] = useState([]);
//   // const [editSystemExperience, setEditSystemExperience] = useState([]);
//   const [isEnable, setIsEnable] = useState({
//     save: false,
//   });
//   const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
//     useState(false);
//   const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
//     useNavigatingAway(canShowDialogLeavingPage);
//   const handleAddFormChange = () => {
//     setSystemExperience([
//       ...systemExperience,
//       {
//         profile: props.profile.userId,
//         system: null,
//         experience: null,
//       },
//     ]);
//   };

//   const handleChange = (event, index, eventName) => {
//     setIsEnable((prevState) => ({ ...prevState, save: true }));
//     setCanShowDialogLeavingPage(true);
//     const values = [...systemExperience];
//     values[index][eventName] = event["id"];
//     setSystemExperience(values);
//   };

//   const handleFormSubmit = (event) => {
//     event.preventDefault();
//     const userSystemExperience = {
//       userId: inputData.userId,
//       systemExperience: systemExperience,
//     };
//     dispatch(updateProfleAction(inputData.userId, userSystemExperience));
//     setIsEnable((prevState) => ({ ...prevState, save: false }));
//     setCanShowDialogLeavingPage(false);
//   };

//   const handleRemoveFormChange = (index) => {
//     setIsEnable((prevState) => ({ ...prevState, save: true }));
//     setCanShowDialogLeavingPage(true);
//     const values = [...systemExperience];
//     values.splice(index, 1);
//     setSystemExperience(values);
//   };

//   function getFields(input, field) {
//     var output = [];
//     for (var i = 0; i < input.length; ++i) output.push(input[i][field]);
//     return output;
//   }

//   useEffect(() => {
//     if (Object.keys(props.profile).length > 0) {
//       const userData = {
//         userId: props.profile.userId,
//       };
//       setInputData(userData);
//       setSystemExperience(
//         props.profile.systemExperience &&
//           props.profile.systemExperience.length === 0
//           ? [
//               {
//                 profile: props.profile.userId,
//                 system: null,
//                 experience: null,
//               },
//             ]
//           : props.profile.systemExperience
//       );
//     }

//     // Grouped Select Options
//     if (props.system.length > 0 && props.systemExpereine.length > 0) {
//       const data = groupByKey(props.systemExpereine, "system");
//       const dataOptions = [
//         {
//           label:
//             props.system[props.system.findIndex((val) => val["id"] === 1)]
//               .system,
//           options: data[1],
//         },
//         {
//           label:
//             props.system[props.system.findIndex((val) => val["id"] === 2)]
//               .system,
//           options: data[2],
//         },
//       ];
//       setGroupedOptions(dataOptions);
//     }
//   }, [props]);

//   return (
//     <div className="row margin-row">
//       <DialogLeavingPage
//         showDialog={showDialogLeavingPage}
//         setShowDialog={setCanShowDialogLeavingPage}
//         confirmNavigation={confirmNavigation}
//         cancelNavigation={cancelNavigation}
//         title={"Systems Experience"}
//       />
//       <div className="row-icon">
//         <img src="\assets\images\profile-page\icon6.png" alt="" />
//         <img
//           className="completed"
//           src="/assets/images/profile-page/Recent_career_summary_active.svg"
//           alt=""
//         />
//       </div>
//       <div className="col-12 ">
//         <div className="timeline-border-box">
//           <h5>Systems Experience</h5>
//           <div className="row">
//             {systemExperience &&
//               systemExperience.map((row, index) => {
//                 return (
//                   <div className="col-12 parent-col" key={index}>
//                     <div className="row cloneRowTarget  ">
//                       <div
//                         className="col-md-6 col-12"
//                         style={{ paddingTop: "1%" }}
//                       >
//                         <label className="field-label">System</label>
//                         <div className="expertise-fields">
//                           <div className="single-field mb-3">
//                             <Select
//                               id="system"
//                               name="system"
//                               value={
//                                 props.systemExpereine &&
//                                 props.systemExpereine.find(
//                                   (system) => system.id === row.system
//                                 )
//                               }
//                               options={groupedOptions}
//                               getOptionLabel={(option) =>
//                                 option.system_experience
//                               }
//                               getOptionValue={(option) => option.id}
//                               onChange={(event) =>
//                                 handleChange(event, index, "system")
//                               }
//                               placeholder="Choose.."
//                               isClearable={true}
//                               styles={customStyles}
//                               isOptionDisabled={(option) =>
//                                 getFields(systemExperience, "system").includes(
//                                   option.id
//                                 )
//                               }
//                             />
//                           </div>
//                         </div>
//                       </div>
//                       <div
//                         className="col-md-5 col-10"
//                         style={{ paddingTop: "1%" }}
//                       >
//                         <label className="field-label">Experience</label>
//                         <div className="expertise-fields">
//                           <div className="single-field mb-3">
//                             <Select
//                               id="experience"
//                               name="experience"
//                               value={
//                                 props.systemExpereineScoring &&
//                                 props.systemExpereineScoring.find(
//                                   (experience) =>
//                                     experience.id === row.experience
//                                 )
//                               }
//                               options={props.systemExpereineScoring}
//                               getOptionLabel={(option) => option.experience}
//                               getOptionValue={(option) => option.id}
//                               onChange={(event) =>
//                                 handleChange(event, index, "experience")
//                               }
//                               placeholder="Choose.."
//                               isClearable={true}
//                               styles={customStyles}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                       {index !== 0 ? (
//                         <div className="col-md-1 col-12 text-right clone-row-btn-holder " style={{marginTop:'21px'}}>
//                           <Link
//                             to=""
//                             style={{ cursor: "pointer" }}
//                             onClick={() => handleRemoveFormChange(index)}
//                             className="cloneTargetTrigger"
//                           >
//                             -
//                           </Link>
//                         </div>
//                       ) : (
//                         ""
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}
//             <div className="col-12 text-right clone-row-btn-holder">
//               <Link
//                 to=""
//                 style={{ cursor: "pointer" }}
//                 onClick={handleAddFormChange}
//                 className="cloneTargetTrigger"
//               >
//                 +
//               </Link>
//             </div>
//           </div>{" "}
//           <br />
//           <div className="col text-right ">
//             {isEnable.save ? (
//               <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                
//                 <span>
//                   <img src="/assets/images/icons/save.png" alt="" />Save
//                 </span>
//               </Link>
//             ) : (
//               ""
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const mapStateToProps = (state) => {
//   const user = state.user.user;
//   const profile = state.user.profile;
//   const system = state.admin.system;
//   const systemExpereine = state.admin.systemExpereine;
//   const systemExpereineScoring = state.admin.systemExpereineScoring;

//   return {
//     user: user,
//     profile: profile,
//     system: system,
//     systemExpereine: systemExpereine,
//     systemExpereineScoring: systemExpereineScoring,
//   };
// };

// const mapDispatchToProps = {};

// export default connect(mapStateToProps, mapDispatchToProps)(SystemExperience);



///////////////////////////////////////////////////////////////////////////

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { updateProfleAction } from "../../../redux/actions/user/userAction";
import { connect } from "react-redux";
import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";

export const SystemExperience = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      top: "5px",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#309CCA" : "#309CCA",
    }),
  };

  const groupByKey = (array, key) => {
    return array.reduce((hash, obj) => {
      if (obj[key] === undefined) return hash;
      return Object.assign(hash, {
        [obj[key]]: (hash[obj[key]] || []).concat(obj),
      });
    }, {});
  };

  const MAX_SYSTEMS = 5; // Max 5 entries


  const dispatch = useDispatch();
  const [groupedOptions, setGroupedOptions] = useState([]);
  const [inputData, setInputData] = useState([]);
  const [systemExperience, setSystemExperience] = useState([]);
  // const [deleteSystemExperienceId, setDeleteSystemExperienceID] = useState([]);
  // const [editSystemExperience, setEditSystemExperience] = useState([]);
  const [isEnable, setIsEnable] = useState({
    save: false,
  });
  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);

  const handleAddFormChange = () => {
    if (systemExperience.length >= MAX_SYSTEMS) {
      alert(`You can add up to ${MAX_SYSTEMS} systems only.`);
      return;
    }

    setSystemExperience([
      ...systemExperience,
      {
        profile: props.profile.userId,
        system: null,
        experience: null,
      },
    ]);
  };


  const handleChange = (event, index, eventName) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);
    const values = [...systemExperience];
    values[index][eventName] = event["id"];
    setSystemExperience(values);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const userSystemExperience = {
      userId: inputData.userId,
      systemExperience: systemExperience,
    };
    dispatch(updateProfleAction(inputData.userId, userSystemExperience));
    setIsEnable((prevState) => ({ ...prevState, save: false }));
    setCanShowDialogLeavingPage(false);
  };

  const handleRemoveFormChange = (index) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);
    const values = [...systemExperience];
    values.splice(index, 1);
    setSystemExperience(values);
  };

  function getFields(input, field) {
    var output = [];
    for (var i = 0; i < input.length; ++i) output.push(input[i][field]);
    return output;
  }

  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      const userData = {
        userId: props.profile.userId,
      };
      setInputData(userData);
      setSystemExperience(
        props.profile.systemExperience &&
          props.profile.systemExperience.length === 0
          ? [
              {
                profile: props.profile.userId,
                system: null,
                experience: null,
              },
            ]
          : props.profile.systemExperience
      );
    }

    // Grouped Select Options
    if (props.system.length > 0 && props.systemExpereine.length > 0) {
      const data = groupByKey(props.systemExpereine, "system");
      const dataOptions = [
        {
          label:
            props.system[props.system.findIndex((val) => val["id"] === 1)]
              .system,
          options: data[1],
        },
        {
          label:
            props.system[props.system.findIndex((val) => val["id"] === 2)]
              .system,
          options: data[2],
        },
      ];
      setGroupedOptions(dataOptions);
    }
  }, [props]);

  const remaining =
  MAX_SYSTEMS -
  (systemExperience && systemExperience.length
    ? systemExperience.length
    : 0);


  return (
    <div className="row margin-row">
      <DialogLeavingPage
        showDialog={showDialogLeavingPage}
        setShowDialog={setCanShowDialogLeavingPage}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
        title={"Systems Experience"}
      />
      <div className="row-icon">
        <img src="\assets\images\profile-page\icon6.png" alt="" />
        <img
          className="completed"
          src="/assets/images/profile-page/Recent_career_summary_active.svg"
          alt=""
        />
      </div>
      <div className="col-12 ">
        <div className="timeline-border-box">
          <h5>Systems Experience</h5>
          <div className="row">
            {systemExperience &&
              systemExperience.map((row, index) => {
                return (
                  <div className="col-12 parent-col" key={index}>
                    <div className="row cloneRowTarget  ">
                      <div
                        className="col-md-6 col-12"
                        style={{ paddingTop: "1%" }}
                      >
                        <label className="field-label">System</label>
                        <div className="expertise-fields">
                          <div className="single-field mb-3">
                            <Select
                              id="system"
                              name="system"
                              value={
                                props.systemExpereine &&
                                props.systemExpereine.find(
                                  (system) => system.id === row.system
                                )
                              }
                              options={groupedOptions}
                              getOptionLabel={(option) =>
                                option.system_experience
                              }
                              getOptionValue={(option) => option.id}
                              onChange={(event) =>
                                handleChange(event, index, "system")
                              }
                              placeholder="Choose.."
                              isClearable={true}
                              styles={customStyles}
                              isOptionDisabled={(option) =>
                                getFields(systemExperience, "system").includes(
                                  option.id
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-5 col-10"
                        style={{ paddingTop: "1%" }}
                      >
                        <label className="field-label">Experience</label>
                        <div className="expertise-fields">
                          <div className="single-field mb-3">
                            <Select
                              id="experience"
                              name="experience"
                              value={
                                props.systemExpereineScoring &&
                                props.systemExpereineScoring.find(
                                  (experience) =>
                                    experience.id === row.experience
                                )
                              }
                              options={props.systemExpereineScoring}
                              getOptionLabel={(option) => option.experience}
                              getOptionValue={(option) => option.id}
                              onChange={(event) =>
                                handleChange(event, index, "experience")
                              }
                              placeholder="Choose.."
                              isClearable={true}
                              styles={customStyles}
                            />
                          </div>
                        </div>
                      </div>
                      {index !== 0 ? (
                        <div className="col-md-1 col-12 text-right clone-row-btn-holder " style={{marginTop:'21px'}}>
                          <Link
                            to=""
                            style={{ cursor: "pointer" }}
                            onClick={() => handleRemoveFormChange(index)}
                            className="cloneTargetTrigger"
                          >
                            -
                          </Link>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                );
              })}
            {remaining > 0 && (
              <div className="col-12 text-right clone-row-btn-holder">
                <Link
                  to=""
                  style={{ cursor: "pointer" }}
                  onClick={handleAddFormChange}
                  className="cloneTargetTrigger"
                >
                  +
                </Link>
              </div>
            )}

          </div>{" "}
          <br />
          <div className="col text-right ">
            {isEnable.save ? (
              <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                
                <span>
                  <img src="/assets/images/icons/save.png" alt="" />Save
                </span>
              </Link>
            ) : (
              ""
            )}
            <p
              style={{
                fontSize: "12px",
                textAlign: "left",
                color:  "#555" // red when max reached
              }}
            >
              {remaining > 0
                ? `${remaining} remaining`
                : "Maximum number of Systems Experience added."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const system = state.admin.system;
  const systemExpereine = state.admin.systemExpereine;
  const systemExpereineScoring = state.admin.systemExpereineScoring;

  return {
    user: user,
    profile: profile,
    system: system,
    systemExpereine: systemExpereine,
    systemExpereineScoring: systemExpereineScoring,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SystemExperience);
